(function() {

    angular
        .module('ngmvac')
        .factory('timeService', TimeService);

    TimeService.$inject = ['$interval'];

    function TimeService($interval) {
        var limit = 1200;
        var counter;
        var idTimer;

        return {
            init: init,
            reset: reset
        }

        function init(params) {
            if(params.limit) {
                limit = params.limit * 60;
            }

            counter = limit;

            if ( params.initialCounting ) {
                counter -= params.initialCounting;
            }

            idTimer = $interval (function() {

                if (counter <= 0) {
                    if (typeof params.end === 'function')
                        params.end();
                    $interval.cancel(idTimer);
                }

                if( typeof params.callback === 'function' ) {
                    params.callback(counter);
                }

                counter--;
            }, 1000);
        }

        function reset() {
            counter = limit;
        }
    }

})();
